import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.emergency-notification': {
         acknowledge: 'Przyjmij',
         acknowledgeAll: 'Przyjmij wszystkie',
         acknowledgedBy: 'Przyjęte przez',
         addNumber: 'Dodaj numer',
         allowsSilentAlarmSOS: 'Umożliwia dyskretne wezwanie pomocy bez zwracania uwagi osób postronnych.',
         cancel: 'Anuluj',
         chooseResponseTeamPractitioners: 'Wybierz Zespół Interwencyjny',
         clickButtonBelowToTriggerTestAlarmAndSendNotifications:
            'Kliknij poniższy przycisk, aby uruchomić próbny alarm i wysłać powiadomienia.',
         close: 'Zamknij',
         contactName: 'Nazwa kontaktu',
         dateAndTime: 'Data i czas',
         emergencyNotificationAccepted: 'Przyjęto zgłoszenie',
         emergencyNotificationHistory: 'Historia zgłoszeń alarmowych',
         emergencyNotificationHistoryEmpty: 'Brak zgłoszeń alarmowych',
         emergencyNotificationHistoryEmptySubheading: 'Nie odnotowano jeszcze żadnego zgłoszenia Cichego alarmu SOS.',
         fetchDataErrorOccurredDuringEmergencyNotificationConfiguration:
            'Wystąpił błąd pobierania danych na potrzeby konfiguracji powiadomień alarmowych.',
         fillContactName: 'Wpisz nazwę kontaktu...',
         fillPhoneNumber: 'Wpisz nr telefonu...',
         noResponseTeamPractitionersSelected: 'Nie wybrano żadnego użytkownika do grupy Zespołu Interwencyjnego.',
         notificationChannel: 'Sposób powiadomienia',
         notificationChannelsMap: {
            IN_APP: 'Komunikat',
            SMS: 'SMS',
         },
         phoneNumber: 'Numer telefonu',
         reportedFrom: 'Zgłaszenie od',
         reporterWithName: 'Osoba zgłaszająca: <bold>{{name}}</bold>',
         resetMessageCustomizablePart: 'Przywróć domyślną treść',
         responseTeamPractitionersWillSeeEmergencyNotificationInApp:
            'Użytkownicy z grupy Zespołu Interwencyjnego zobaczą komunikat alarmowy na swoich komputerach.',
         save: 'Zapisz',
         sendSmsNotifications: 'Wysyłaj wiadomości SMS',
         showInAppNotification: 'Pokazuj komunikat alarmowy w aplikacji eGabinet',
         silentAlarmSOS: 'Cichy alarm SOS',
         smsNotificationsWillBeSentToTheFollowingPhoneNumbersYouCanAddPeopleFromWorkSecurityOrFamily:
            'Na poniższe numery telefonów zostaną wysłane powiadomienia o uruchomieniu alarmu. Możesz dodać np. osoby z pracy, ochrony lub rodziny.',
         smsPreview: 'Podgląd SMS',
         smsText: 'Treść SMS',
         sos: 'SOS',
         sosAlarm: 'Alarm SOS',
         sosAlarmDismissed: 'Alarm odwołany',
         sosAlarmDismissedByReporter: 'Alarm został odwołany przez osobę zgłaszającą.',
         sosAlarmHasBeenCalled: 'Zgłoszono Cichy alarm. Wymagane jest natychmiastowe działanie.',
         sosAssistanceOnTheWay: 'Pomoc w drodze',
         sosCancel: 'Odwołaj',
         sosCancelWithEscapeKey: 'Odwołaj (Esc)',
         sosFailedToCancel: 'Nie powiodło się odwołanie alarmu.',
         sosFailedToTrigger: 'Nie powiodło się uruchomienie alarmu.',
         sosSendImmediately: 'Zgłoś natychmiast',
         sosSent: 'Wysłano zgłoszenie',
         sosTestAlarm: 'Testowy Alarm SOS',
         sosWillBeSentInSeconds: 'Zgłoszenie zostanie wysłane za <bold>{{seconds}} sekundy...</bold>',
         status: 'Status',
         statusesMap: {
            ACKNOWLEDGED: 'Przyjęty',
            DISMISSED: 'Odwołany',
            NOT_ACKNOWLEDGED: 'Nieprzyjęty',
            TEST: 'Test alarmu',
         },
         successfullySetConfiguration: 'Konfiguracja Cichego alarmu SOS została zapisana.',
         testAlarm: 'Test alarmu',
         testAlarmAndNotifications: 'Przetestuj alarm i powiadomienia',
         time: 'Czas: {{time}}',
         user: 'Użytkownik',
         usersDeclensionMap: {
            accusative: 'użytkownika',
            genitive: 'użytkowników',
            plural: 'użytkowników',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.emergency-notification');
